import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const Ctx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const check = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    check();
  }, [check]);

  const logout = async () => {
    await http.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <Ctx.Provider value={{ user, setUser, check, logout }}>{children}</Ctx.Provider>;
}

export const useAdmin = () => useContext(Ctx);
